//import $ from 'jquery';
//export let cleaveObj = false;
//3776 Indian Run Drive, Canfield, OH, United States

import { initStateDropDownBox } from './state-dropdown';
import { initFancyInputBox } from './fancy-input';

export const autocomplete = () => {
  if (document.getElementById('address1') !== null) {
    const autocompleteFormField = document.getElementById('address1');
    const autocomplete = new google.maps.places.Autocomplete(
      autocompleteFormField,
      {
        types: [`address`],
      }
    );
    google.maps.event.clearInstanceListeners(autocompleteFormField);
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      // Custom methods to populate form fields.
      const place = autocomplete.getPlace();
      fillInAddress(place);
    });
  }
};

/**
 * Listner method that gets called when user selects address from Google Autocomplete
 */
const fillInAddress = place => {
  const localCountryMapper = {
    af: '3',
    ax: '16',
    al: '6',
    dz: '61',
    as: '12',
    ad: '1',
    ao: '9',
    ai: '5',
    aq: '10',
    ag: '4',
    ar: '11',
    am: '7',
    aw: '15',
    au: '14',
    at: '13',
    az: '17',
    bs: '32',
    bh: '24',
    bd: '20',
    bb: '19',
    by: '36',
    be: '21',
    bz: '37',
    bj: '26',
    bm: '28',
    bt: '33',
    bo: '30',
    bq: '248',
    ba: '18',
    bw: '35',
    bv: '34',
    br: '31',
    io: '105',
    bn: '29',
    bg: '23',
    bf: '22',
    bi: '25',
    kh: '116',
    cm: '47',
    ca: '38',
    cv: '52',
    ky: '123',
    cf: '41',
    td: '212',
    cl: '46',
    cn: '48',
    cx: '53',
    cc: '39',
    co: '49',
    km: '118',
    cg: '42',
    cd: '40',
    ck: '45',
    cr: '50',
    ci: '44',
    hr: '97',
    cu: '51',
    cw: '249',
    cy: '54',
    cz: '55',
    dk: '58',
    dj: '57',
    dm: '59',
    do: '60',
    ec: '62',
    eg: '64',
    sv: '208',
    gq: '87',
    er: '66',
    ee: '63',
    et: '68',
    fk: '71',
    fo: '73',
    fj: '70',
    fi: '69',
    fr: '74',
    gf: '79',
    pf: '174',
    tf: '213',
    ga: '75',
    gm: '84',
    ge: '78',
    de: '56',
    gh: '81',
    gi: '82',
    gr: '88',
    gl: '83',
    gd: '77',
    gp: '86',
    gu: '91',
    gt: '90',
    gg: '80',
    gn: '85',
    gw: '92',
    gy: '93',
    ht: '98',
    hm: '95',
    va: '233',
    hn: '96',
    hk: '94',
    hu: '99',
    is: '108',
    in: '104',
    id: '100',
    ir: '107',
    iq: '106',
    ie: '101',
    im: '103',
    il: '102',
    it: '109',
    jm: '111',
    jp: '113',
    je: '110',
    jo: '112',
    kz: '124',
    ke: '114',
    ki: '117',
    kp: '120',
    kr: '121',
    kw: '122',
    kg: '115',
    la: '125',
    lv: '134',
    lb: '126',
    ls: '131',
    lr: '130',
    ly: '135',
    li: '128',
    lt: '132',
    lu: '133',
    mo: '147',
    mk: '143',
    mg: '141',
    mw: '155',
    my: '157',
    mv: '154',
    ml: '144',
    mt: '152',
    mh: '142',
    mq: '149',
    mr: '150',
    mu: '153',
    yt: '243',
    mx: '156',
    fm: '72',
    md: '138',
    mc: '137',
    mn: '146',
    me: '139',
    ms: '151',
    ma: '136',
    mz: '158',
    mm: '145',
    na: '159',
    nr: '168',
    np: '167',
    nl: '165',
    nc: '160',
    nz: '170',
    ni: '164',
    ne: '161',
    ng: '163',
    nu: '169',
    nf: '162',
    mp: '148',
    no: '166',
    om: '171',
    pk: '177',
    pw: '184',
    ps: '182',
    pa: '172',
    pg: '175',
    py: '185',
    pe: '173',
    ph: '176',
    pn: '180',
    pl: '178',
    pt: '183',
    pr: '181',
    qa: '186',
    re: '187',
    ro: '188',
    ru: '190',
    rw: '191',
    bl: '27',
    sh: '198',
    kn: '119',
    lc: '127',
    mf: '140',
    pm: '179',
    vc: '234',
    ws: '241',
    sm: '203',
    st: '207',
    sa: '192',
    sn: '204',
    rs: '189',
    sc: '194',
    sl: '202',
    sg: '197',
    sx: '247',
    sk: '201',
    si: '199',
    sb: '193',
    so: '205',
    za: '244',
    gs: '89',
    ss: '250',
    es: '67',
    lk: '129',
    sd: '195',
    sr: '206',
    sj: '200',
    sz: '210',
    se: '196',
    ch: '43',
    sy: '209',
    tw: '225',
    tj: '216',
    tz: '226',
    th: '215',
    tl: '218',
    tg: '214',
    tk: '217',
    to: '221',
    tt: '223',
    tn: '220',
    tr: '222',
    tm: '219',
    tc: '211',
    tv: '224',
    ug: '228',
    ua: '227',
    ae: '2',
    gb: '76',
    us: '230',
    um: '229',
    uy: '231',
    uz: '232',
    vu: '239',
    ve: '235',
    vn: '238',
    vg: '236',
    vi: '237',
    wf: '240',
    eh: '65',
    ye: '242',
    zm: '245',
    zw: '246',
  };

  const localStateMapper = [];
  localStateMapper['230'] = {
    al: '3583',
    ak: '3584',
    az: '3585',
    ar: '3586',
    ca: '3587',
    co: '3588',
    ct: '3589',
    de: '3590',
    dc: '3633',
    fl: '3591',
    ga: '3592',
    hi: '3593',
    id: '3594',
    il: '3595',
    in: '3596',
    ia: '3597',
    ks: '3598',
    ky: '3599',
    la: '3600',
    me: '3601',
    md: '3602',
    ma: '3603',
    mi: '3604',
    mn: '3605',
    ms: '3606',
    mo: '3607',
    mt: '3608',
    ne: '3609',
    nv: '3610',
    nh: '3611',
    nj: '3612',
    nm: '3613',
    ny: '3614',
    nc: '3615',
    nd: '3616',
    oh: '3617',
    ok: '3618',
    or: '3619',
    pa: '3620',
    ri: '3621',
    sc: '3622',
    sd: '3623',
    tn: '3624',
    tx: '3625',
    ut: '3626',
    vt: '3627',
    va: '3628',
    wa: '3629',
    wv: '3630',
    wi: '3631',
    wy: '3632',
  };
  let stateLists = [];
  /*
	const administrativeType = [];
	administrativeType['76'] = "administrative_area_level_2"; // United Kingdom-GB
	administrativeType['109'] = "administrative_area_level_2"; // Italy-IT
	administrativeType['67'] = "administrative_area_level_1"; // Spain-ES-ok
	administrativeType['56'] = "administrative_area_level_1"; // Germany-DE
	administrativeType['74'] = "administrative_area_level_1"; // France-FR
	administrativeType['101'] = "administrative_area_level_1"; // Ireland-IE
	administrativeType['165'] = "administrative_area_level_1"; // Netherland-NR
	administrativeType['31'] = "administrative_area_level_1"; // Brazil-BR
	administrativeType['38'] = "administrative_area_level_1"; // Canada-CA
	administrativeType['14'] = "administrative_area_level_1"; // Austrlia-AU
	administrativeType['43'] = "administrative_area_level_1"; // Austrlia-AU
	*/

  let street = '';
  let routee;
  let countryId = false;
  let stateAbb = false;
  let stateFull;
  let stateAbb2 = false;
  let stateFull2;
  let stateId = false;

  const componentForm = {
    locality: 'long_name', //city
    postal_code: 'short_name', //zip or postal code
    postal_town: 'long_name,',
  };

  // Get the place details from the autocomplete object.
  for (var component in componentForm) {
    if (document.getElementById(component)) {
      document.getElementById(component).value = '';
      document.getElementById(component).disabled = false;
    }
  }
  document.getElementById('address2').value = '';
  document.getElementById('state').value = '';

  let addressType = '';
  for (var i = 0; i < place.address_components.length; i++) {
    addressType = place.address_components[i].types[0];

    //handle city and zip code
    if (componentForm[addressType]) {
      let val = place.address_components[i][componentForm[addressType]];
      if (val == undefined) val = '';
      if (document.getElementById(addressType))
        document.getElementById(addressType).value = val;

      if (addressType == 'postal_town') {
        if (val == '') {
          val = place.address_components[i][componentForm['street_number']];
          if (val == undefined) val = '';
        }
        document.getElementById('locality').value = val;
      }
    }

    //handle country
    if (addressType == 'country') {
      var country = place.address_components[i]['short_name'];
      const curCountry = document.getElementById('country').value;
      if (localCountryMapper[country.toLowerCase()]) {
        countryId = localCountryMapper[country.toLowerCase()];
        document.getElementById('country').value = countryId;
        if (curCountry !== countryId) {
          initStateDropDownBox();
        }
      }
    }

    // Handle state Phase I
    // indicates a first-order civil entity below the country level.
    // Within the United States, these administrative levels are states.
    // Not all nations exhibit these administrative levels. In most cases,
    // administrative_area_level_1 short names will closely match ISO 3166-2
    // subdivisions and other widely circulate
    // For USA, this will be states - not applicable for all countries
    if (addressType == 'administrative_area_level_1') {
      stateAbb = place.address_components[i]['short_name'];
      stateFull = place.address_components[i]['long_name'];
      stateAbb = stateAbb.toLowerCase();
      stateFull = stateFull.toLowerCase();
    }

    // Handle state Phase II
    // indicates a second-order civil entity below the country level.
    // Within the United States, these administrative levels are counties.
    // Not all nations exhibit these administrative levels.
    if (addressType == 'administrative_area_level_2') {
      stateAbb2 = place.address_components[i]['short_name'];
      stateFull2 = place.address_components[i]['long_name'];
      stateAbb2 = stateAbb2.toLowerCase();
      stateFull2 = stateFull2.toLowerCase();
    }

    //handle street address
    if (addressType == 'street_number' || addressType == 'postal_town') {
      street = place.address_components[i]['long_name'];
      if (street.length >= 1) {
        street = street;
      } else {
        street = '';
      }
    }

    // Route
    if (addressType == 'route') {
      routee = place.address_components[i]['long_name'];
    }
    if (routee) {
      document.getElementById('address1').value = street + ' ' + routee;
    }
    addressType = '';
  }

  //Set State from dropdown : handle state Phase II
  if (countryId && stateAbb) {
    //look for USA: local state mapper for statelist mapping before making ajax call
    if (localStateMapper[countryId]) {
      stateLists = localStateMapper[countryId];
      if (stateLists[stateAbb]) {
        stateId = stateLists[stateAbb];
        //getStatesList(countryId, stateId);
        // $("#state").val(stateAbb);
        setState(stateId, countryId, 1);
      } else {
        //not selecting state
      }
      // $('.js-state-error').html('');
    } else {
      // Not-USA Countries
      $.post(
        '/service/getstatesmatchajax', // url
        { country: countryId }, // data
        function(data) {
          stateLists = data;

          if (stateLists !== false && stateLists !== null) {
            if (countryId == '101') {
              // remove conty from the stToLook
              stateAbb = stateAbb.replace('county', '').trim();
            }

            const successFirstAttempt = setLookUp(
              stateAbb,
              stateFull,
              stateLists,
              countryId
            );

            if (successFirstAttempt == false && stateAbb2 !== false) {
              setLookUp(stateAbb2, stateAbb2, stateLists, countryId);
            }
          } else {
            //no states available
          }
        }, // callback
        'json' // type
      );
    }
  } else {
    // no states available
  }

  $('.js-state-error').html('');
  initFancyInputBox();
};

const setLookUp = (stToLookAbb, stToLookbFull, stateLists, countryId) => {
  let stateId = '';
  if (stateLists['abb'][stToLookAbb]) {
    stateId = stateLists['abb'][stToLookAbb];
    setState(stateId, countryId, 1);
    return true;
  } else if (stateLists['full'][stToLookAbb]) {
    stateId = stateLists['full'][stToLookAbb];
    setState(stateId, countryId, 1);
    return true;
  } else if (stateLists['full'][stToLookbFull]) {
    stateId = stateLists['full'][stToLookbFull];
    setState(stateId, countryId, 1);
    return true;
  } else if (stateLists['full'][stToLookbFull]) {
    stateId = stateLists['full'][stToLookbFull];
    setState(stateId, countryId, 1);
    return true;
  }
  return false;
};

/**
 * Set state dropdown value
 */
const setState = (stateId, countryId, attemptCounter) => {
  const stateCountry = document
    .getElementById('state')
    .getAttribute('data-country');
  const maxAttempt = 5;
  if (stateCountry == countryId) {
    document.getElementById('state').value = stateId;
  } else {
    if (attemptCounter <= maxAttempt) {
      setTimeout(function() {
        setState(stateId, countryId, attemptCounter++);
      }, 500);
    } else {
      document.getElementById('state').value = stateId;
    }
  }
};
